import { render, staticRenderFns } from "./EditLastMile.vue?vue&type=template&id=0226d65d"
import script from "./EditLastMile.vue?vue&type=script&lang=js"
export * from "./EditLastMile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports